if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading__spinner"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading__spinner"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

// ================================================== Code To Hide Unavailable Product Start ==================================================
const variantSelects = document.querySelector("variant-selects")
  ? document.querySelector("variant-selects")
  : document.querySelector("variant-radios");
const pickerType =
  variantSelects.querySelectorAll("fieldset").length > 0 ? "radios" : "selects";
const fieldsets =
  pickerType == "radios"
    ? Array.from(variantSelects.querySelectorAll("fieldset"))
    : Array.from(
        variantSelects.querySelectorAll(".product-form__input--dropdown")
      );
const productJson = JSON.parse(
  variantSelects.querySelector('[type="application/json"]').textContent
);
let selectedOptions = [];
variantSelects.addEventListener("change", rebuildOptions);
this.rebuildOptions();

function validCombo(inputValue, optionLevel) {
  for (let i = 0; i < productJson.length; i++) {
    if (optionLevel == 1) {
      if (
        productJson[i].option1 == selectedOptions[0] &&
        productJson[i].option2 == inputValue
      ) {
        return true;
      }
    } else {
      if (
        productJson[i].option1 == selectedOptions[0] &&
        productJson[i].option2 == selectedOptions[1] &&
        productJson[i].option3 == inputValue
      ) {
        return true;
      }
    }
  }
}

function rebuildOptions() {
  selectedOptions = fieldsets.map((fieldset) => {
    return pickerType == "radios"
      ? Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        ).value
      : Array.from(
          fieldset.querySelectorAll("select"),
          (select) => select.value
        );
  });
  for (
    let optionLevel = 1, n = fieldsets.length;
    optionLevel < n;
    optionLevel++
  ) {
    const inputs =
      pickerType == "radios"
        ? fieldsets[optionLevel].querySelectorAll("input")
        : fieldsets[optionLevel].querySelectorAll("option");

    inputs.forEach((input) => {
      input.disabled = validCombo(input.value, optionLevel) ? false : true;

      if (pickerType == "radios") {
        const label = fieldsets[optionLevel].querySelector(
          `label[for="${input.id}"]`
        );

        label.style.display = input.disabled ? "none" : ""; //Hide the option, or comment this line out and use the following lines to style it..
        //label.style.opacity = (input.disabled) ? 0.5 : 1;
        //label.style.borderStyle = (input.disabled) ? "dashed" : "solid";
        //label.style.textDecoration = (input.disabled) ? "none" : "";
      } else {
        input.hidden = validCombo(input.value, optionLevel) ? false : true;
      }
    });
  }
  for (
    let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false;
    optionLevel < fieldsetsLength && !change;
    optionLevel++
  ) {
    if (pickerType == "radios") {
      if (
        fieldsets[optionLevel].querySelector("input:checked").disabled === true
      ) {
        change = fieldsets[optionLevel].querySelector(
          "input:not(:disabled)"
        ).checked = true;
      }
    } else {
      if (
        fieldsets[optionLevel].querySelector("option:checked").disabled === true
      ) {
        change = fieldsets[optionLevel].querySelector(
          "option:not(:disabled)"
        ).selected = "selected";
      }
    }
    if (change)
      variantSelects.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
// ================================================== Code To Hide Unavailable Product End ==================================================

// ================================================== Code To Diplay Variant Selection Line By Line Start ==================================================
document.addEventListener("DOMContentLoaded", function () {
  // Get all variant pickers
  const variantPickers = document.querySelectorAll(
    ".product-form__input.product-form__input--dropdown"
  );

  // Hide all variant pickers except the first one
  variantPickers.forEach((picker, index) => {
    if (index > 0) picker.style.display = "none";
  });

  // Function to count valid (non-disabled and non-hidden) options
  function countValidOptions(selectElement) {
    return Array.from(selectElement.options).filter(
      (option) => !option.classList.contains("unavailable")
    ).length;
  }

  // Function to display the next picker
  function showNextPicker(currentIndex) {
    if (currentIndex + 1 < variantPickers.length) {
      const nextPicker = variantPickers[currentIndex + 1];
      const nextSelectElement = nextPicker.querySelector("select");

      // Get the count of valid options in the next dropdown
      const validOptionsCount = countValidOptions(nextSelectElement);

      // Show the next picker if it has valid options
      if (validOptionsCount > 0) {
        nextPicker.style.display = "flex";
      }

      // If the next dropdown has only one valid option, automatically show the following picker
      if (validOptionsCount === 1) {
        showNextPicker(currentIndex + 1);
      }
    }
  }

  // Initial setup: show next picker if the first picker has only one valid option
  variantPickers.forEach((picker, index) => {
    const selectElement = picker.querySelector("select");
    const validOptionsCount = countValidOptions(selectElement);

    if (index === 0 || validOptionsCount === 1) {
      showNextPicker(index);
    } else {
      // Show the next picker on change
      selectElement.addEventListener("change", function () {
        showNextPicker(index);
      });
    }
  });
});
